export const folderObjectIdPath = "/newui/folders/:folderObjectId";

export const objectIdPaths = [
  "/newui/folders/:folderObjectId",
  "/newui/folders/:folderObjectId/documents/new",
  "/newui/documents/:objectId",
  "/newui/journals/:objectId",
  "/newui/journals/:objectId/entries/:entryId",
  "/newui/metrics/:objectId",
  "/newui/metrics/:objectId/measurements/:measurementId",
  "/newui/floor_plans/:objectId",
  "/newui/floor_plans_fullscreen/:objectId"
];